import { useEffect, useState } from "react";

const getColorSchemeDark = () => window?.matchMedia("(prefers-color-scheme: dark)");

export const useIsDarkMode = () => {
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    const darkModeQ = getColorSchemeDark();
    if (darkModeQ.matches) {
      setIsDark(true);
    }

    const handleChange = () => {
      const newModeQ = getColorSchemeDark();
      setIsDark(
        newModeQ?.matches || document.documentElement.getAttribute("data-theme") === "dark",
      );
    };

    darkModeQ?.addEventListener("change", handleChange);
    const observer = new MutationObserver(handleChange);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => {
      observer.disconnect();
      darkModeQ.removeEventListener("change", handleChange);
    };
  }, []);
  return isDark;
};
